import { render } from "./MsWord.vue?vue&type=template&id=04e4482b&scoped=true"
import script from "./MsWord.vue?vue&type=script&lang=js"
export * from "./MsWord.vue?vue&type=script&lang=js"

import "./MsWord.vue?vue&type=style&index=0&id=04e4482b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04e4482b"]])

export default __exports__